import type { WorkspacePort } from '@crowdex/workspace-protocol';
import type { CloudRuntime } from '@/lib/cloud-runtime/cloud-runtime';
import { PREVIEW_LOCAL_PORTS } from '@/lib/desktop-preview-files';
import { isLocalMachine } from '@/lib/local-runtime';
import { useCloudWorkspaceClient } from '@/lib/side-panel/use-cloud-workspace-client';
import { useLocalPorts } from '@/lib/side-panel/use-local-ports';
import { useLocalWorkspaceClient } from '@/lib/side-panel/use-local-workspace-client';

/** The summary says nothing of a workspace it cannot reach: the Ports tool does. */
const ignore = () => undefined;

/**
 * The servers listening in the conversation's workspace (a dev server), read while the summary
 * shows: the cloud sandbox's, or this computer's. The preview shows the boards' (D38).
 */
export function useSummaryServers({
  visible,
  preview,
  workspace,
  cloudRuntime,
}: {
  visible: boolean;
  preview: boolean;
  workspace: string | null;
  cloudRuntime: CloudRuntime | null;
}): readonly WorkspacePort[] {
  const live = visible && !preview;
  const cloudClient = useCloudWorkspaceClient(live ? cloudRuntime : null, ignore);
  const local = useLocalWorkspaceClient(
    live && cloudRuntime === null && isLocalMachine() ? workspace : null,
    ignore,
  );
  const ports = useLocalPorts(cloudClient ?? local.client, live);
  return preview ? PREVIEW_LOCAL_PORTS : ports;
}
